import classes from "./CreateEditMedicationTemplateDetails.module.scss";
import { TextInput } from "../../../../common/InputComponents/TextInput/TextInput";

export const CreateEditMedicationTemplateDetails = ({ formik }: any) => {
  return (
    <div className={classes.treatmentPlanDetailsContainer}>
      <h2>Medication Template</h2>
      <TextInput
        id="name"
        label="Template Name"
        type="text"
        required
        maxLength={70}
        formik={formik}
        inputClassName={classes.input}
        helperClassName={classes.helper}
        labelClassName={classes.label}
        formClassName={classes.formControl}
      />
    </div>
  );
};
